import React from "react";
import PropTypes from "prop-types";
import { PageTitle } from "./PageTitle";
import { ContentContainer } from "./ContentContainer";

function ContentManagement(props) {
    const { title, body } = props;

    return (
        <div>
            <PageTitle title={title}/>
            <ContentContainer>
                <div className="row">
                    <div className="col-md-12" dangerouslySetInnerHTML={{ __html: body }}/>
                </div>
            </ContentContainer>
        </div>
    );
}

ContentManagement.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string
};

export default ContentManagement;